<ng-template #template>
    <div class="modal-body">
        <span class="bold">{{ undeletableMeta.groupName }}</span> can not be removed as following fields are mapped:
        <ul>
            <li *ngFor="let fieldName of undeletableMeta.fieldNames">{{ fieldName }}</li>
        </ul>
    </div>
    <div class="modal-footer"><button type="button" class="btn btn-primary" (click)="close()">OK</button></div>
</ng-template>
